<header class="topbar">
  <!-- Mobile Menu Toggle -->
  <button class="menu-toggle d-md-none" (click)="onToggleSidebar()">
    <i class="bi bi-list"></i>
  </button>

  <!-- Page Title / Breadcrumbs (can be added later) -->
  <div class="topbar-left">
    <!-- Update Available -->
    <button *ngIf="updateAvailable()" class="update-btn" (click)="reloadForUpdate()"
      aria-label="Update available" title="A new version is available">
      <i class="bi bi-arrow-repeat"></i>
      <span class="update-text">Update Available</span>
    </button>
  </div>

  <!-- Right Side Actions -->
  <div class="topbar-right">
    <!-- Theme Toggle -->
    <button class="theme-toggle-btn" (click)="toggleTheme()" [attr.aria-label]="'Switch to ' + ((currentTheme$ | async) === 'light' ? 'dark' : 'light') + ' mode'">
      <i class="bi" [ngClass]="(currentTheme$ | async) === 'light' ? 'bi-moon-stars' : 'bi-sun'"></i>
    </button>

    <!-- Activity Bell -->
    <button class="activity-btn" (click)="goToActivity()" aria-label="Activity" title="Activity">
      <i class="bi bi-bell"></i>
      <span *ngIf="hasUnseenActivity()" class="activity-badge"></span>
    </button>

    <!-- User Profile Dropdown -->
    <div class="user-menu position-relative" [class.show]="showUserMenu">
      <button class="user-profile-btn" (click)="toggleUserMenu()">
        <i class="bi bi-person-circle user-icon"></i>
        <span class="user-name">{{ getUserName() }}</span>
        <i class="bi bi-chevron-down chevron-icon"></i>
      </button>

      <!-- Dropdown Menu -->
      <div class="dropdown-menu" [class.show]="showUserMenu">
        <button class="dropdown-item" (click)="goToProfile()">
          <i class="bi bi-person"></i>
          Profile
        </button>
        <button *ngIf="isOwnerOrChiefSupervisor()" class="dropdown-item" (click)="goToCompanyProfile()">
          <i class="bi bi-building"></i>
          Company Profile
        </button>
        <button class="dropdown-item" (click)="goToTeam()">
          <i class="bi bi-people"></i>
          Team Members
        </button>
        <hr class="dropdown-divider" />
        <button class="dropdown-item text-danger" (click)="logout()">
          <i class="bi bi-box-arrow-right"></i>
          Logout
        </button>
      </div>
    </div>
  </div>
</header>
